import {
  differenceInDays,
  format,
  parseISO,
  startOfDay,
  subMonths,
} from 'date-fns';

/** Format matching the dashboard-analytics-service expectation: no Z, local time. */
export const API_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSS";

export function formatApiDate(date: Date): string {
  return format(date, API_DATE_FORMAT);
}

/** True when the selected range is ≤ 31 days — gates KPI trend arrows. */
export function shouldShowDifference(
  startDate?: string,
  endDate?: string,
): boolean {
  if (!startDate || !endDate) return false;
  try {
    return differenceInDays(parseISO(endDate), parseISO(startDate)) <= 31;
  } catch {
    return false;
  }
}

/** Default filter: last 30 days → today, formatted without Z to match old frontend. */
export function defaultDateRange(): { startDate: string; endDate: string } {
  const today = startOfDay(new Date());
  return {
    startDate: formatApiDate(subMonths(today, 1)),
    endDate: formatApiDate(today),
  };
}
